const subnavEl = document.getElementById('subnav');

const subnav = () => {
    if (subnavEl !== null) {
        const subnavButton = document.querySelector('.subnav__toggle-button');

        subnavButton.addEventListener('click', function(e) {
            e.preventDefault();
            e.target.parentElement.classList.toggle('active');
        });
    }
};

export default subnav;
